import { useEffect } from "react";

// Sets the document title for a route and restores the brand default on unmount.
export function usePageTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => { document.title = prev; };
  }, [title]);
}
